import * as React from 'react';
import { FunctionComponent, useContext } from 'react';

//MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

//Custom Components
import UserContext from '@/components/UserContext/UserContext';

//Types
import { IFormTabPanel } from '@/@types/ui/Form';
import { UserContextType } from '@/@types/context/UserContext';

const FormTabPanel: FunctionComponent<React.PropsWithChildren<IFormTabPanel>> = (props) => {
  const userContext = useContext(UserContext) as UserContextType;

  const { children, value, index, needPermission, padding, noBox, mountInvisible } = props;

  return needPermission && !userContext.hasAnyPermission(needPermission) ? null : (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
    >
      {!mountInvisible ? (
        value === index ? (
          <Box p={noBox ? 0 : 3} style={{ padding: padding }}>
            {children}
          </Box>
        ) : null
      ) : (
        <Box visibility={value === index ? 'visible' : 'hidden'} p={noBox ? 0 : 3} style={{ padding: padding }}>
          {children}
        </Box>
      )}
    </Typography>
  );
};

export default FormTabPanel;
